<template>
<div class="wrapper">
    <text-input as-text-area
                :input-id="file.name + '-preview'"
                readonly=""
                :value = "file.preview" />
    <div class="info">
        <span>
            {{ prettifySize(1025) }}
        </span>
        <a :href="downloadLink" download>Скачать</a>
    </div>
</div>
</template>

<script>
import TextInput from './TextInput'
import { TasksAPI } from 'api-client'

export default {
  name: "FilePreview",
  components: {
    TextInput
  },
  props: {
    file: {
      type: Object,
      required: true,
      default() {
        return {
          name: "",
          size: 0,
          linesCount: 0,
          downloadLink: "",
          preview: "",
        }
      },
    },
  },
  computed: {
    downloadLink() {
      return TasksAPI.downloadResultRoute(this.file)
    },
  },
  methods: {
    formatSize(bytes, div, unit) {
      const s = bytes / div;
      if (Number.isInteger(Math.trunc(s * 100))) {
        return `${s.toFixed(0)} ${unit}`;
      }
      return `${s.toFixed(2)} ${unit}`;
    },
    prettifySize(bytes) {
      if (bytes >= 1024*1024) {
        return this.formatSize(bytes, 1024*1024, 'Mb')
      }
      if (bytes >= 1024) {
        return this.formatSize(bytes, 1024, 'Kb')
      }
      return this.formatSize(bytes, 1, 'bytes')
    },
  },
}
</script>

<style lang="sass" scoped>
    .wrapper
        margin-bottom: gridSteps(2)
    .info
        text-align: right
</style>
